import { type Common } from './common.js';
import {
  type Connection,
  type ConnectionApi,
  type ConnectionInterfaceEngine,
  type ConnectionSftp,
  type FindAllOptions,
  type FindInterfaceEngineEventsOptions,
  type InterfaceEngineEventsResponse,
} from './models/connection.js';

export class API {
  common: Common;
  baseEndpoint = '/connections';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<{ connections: Connection[] }> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(args: {
    /**
     * FIXME: Remove detailPath as a parameter once we have one endpoint that handles all connection types.
     */
    detailPath: string;
  }): Promise<{ connection: ConnectionApi | ConnectionSftp | ConnectionInterfaceEngine }> {
    const { detailPath } = args;
    const url = this.common.constructPath(detailPath);
    return await this.common.getJSON(url);
  }

  async findEvents(
    options: FindInterfaceEngineEventsOptions
  ): Promise<InterfaceEngineEventsResponse> {
    const { detailPath, ...rest } = options;
    const url = this.common.constructPath(detailPath, rest);
    return await this.common.getJSON(url);
  }
}
